import emailValidator from 'email-validator';
import isUrl from 'is-url';

export const isEmailValid = value => {
  if (!value) {
    return false;
  }
  return emailValidator.validate(value);
};

export const isPasswordValid = value => {
  return value != null && value !== '';
};

export const isUrlValid = value => {
  if (!value) {
    return false;
  }
  return isUrl(value);
};

export const isNumeric = value => {
  return /^-?\d+$/.test(value);
};

/**
 * Ensures a redirect URL is a safe relative path to prevent open redirect attacks.
 * Rejects protocol-relative URLs (//evil.com), absolute URLs, and non-string values.
 */
export const getSafeRedirectPath = (url, fallback = '/') => {
  if (typeof url !== 'string') return fallback;
  if (url.startsWith('/') && !url.startsWith('//')) return url;
  return fallback;
};

export default {
  isEmailValid,
  isPasswordValid,
  isUrlValid,
  isNumeric,
  getSafeRedirectPath,
};
